export const FILIAL_DEFAULT_C001 = "C001";
